import { Close } from "@mui/icons-material";
import { Box, DialogTitle, IconButton, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export function MapEditorFeatureCreateDialogTitle({ onClose }: { onClose: () => void }) {
    const { t } = useTranslation("mapEditor");
    return (
        <DialogTitle
            component={Stack}
            direction="row"
            justifyContent="space-between"
            sx={theme => ({
                borderBottom: `1px solid ${theme.palette.divider}`,
                padding: 2,
            })}
        >
            <Stack>
                <Typography variant="h2">{t("mapEditorFeatureCreateDialog.title")}</Typography>
                <Typography>{t("mapEditorFeatureCreateDialog.subtitle")}</Typography>
            </Stack>
            <Box>
                <IconButton onClick={onClose}>
                    <Close />
                </IconButton>
            </Box>
        </DialogTitle>
    );
}
